import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import { connect } from 'react-redux';
import { theme } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({
  theme,
});

export const completedColor = ({ theme }) => theme.palette.primary;

export default compose(connect(mapStateToProps), addProps({ completedColor }));
